import axios from 'axios';
import {systemEnvironmentApiUrl} from '../../../helpers/url';

/**
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export function watchDog(data) {
    return axios
        .post(`${systemEnvironmentApiUrl()}/api/v1/course/watchdog/create`, data)
        .then((response) => response.data);
}




// WEBPACK FOOTER //
// ./src/components/ssv/api/course.js